import * as yup from 'yup'

export const notebookInFolderClientSchema = yup.object({
	folderId: yup.number().required('Campo obrigatório'),
	notebookId: yup.number().required('Campo obrigatório'),
})
